import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import UnAuthArticlePostItem from "../post/UnAuthArticlePostItem";
import UnAuthVideoPostItem from "../post/unAuthVideoPostItem";
import UnAuthAudioPostItem from "../post/UnAuthAudioPostItem";
import UnAuthPhotosPostItem from "../post/UnAuthPhotosPostItem";
import UnAuthLinkPostItem from "../post/UnAuthLinkPostItem";
import UnAuthSharePostItem from "../post/UnAuthSharePostItem";
import UnAuthQuotePostItem from "../post/unAuthQuotePostItem";
import LazyLoad from "react-lazyload";

export default class UnAuthProjectActivity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      postList: [],
      responseMessage: "",
      postMaxSize: 10,
      thresholdHeight: 1000,
    };
    this.getLatestPosts = this.getLatestPosts.bind(this);
  }

  componentDidMount() {
    console.log("project Id", this.props.project);
    this.getLatestPosts(0, this.state.postMaxSize, false);
  }

  getLatestPosts(page, size, concatWithPrevious) {
    if (!page) {
      page = 0;
    }
    if (!size) {
      size = 10;
    }
    if (concatWithPrevious === undefined) {
      concatWithPrevious = false;
    }
    axios({
      method: "get",
      url:
        process.env.REACT_APP_userServiceURL +
        "/unauth/project/getNewsFeed?projectId=" +
        this.props.project.projectId +
        "&newsFeedType=LATEST" +
        "&page=" +
        page +
        "&size=" +
        10,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    })
      .then((response) => {
        if (
          response &&
          response.data &&
          response.data.body &&
          response.status === 200
        ) {
          let pagedData = response.data.body;
          if (
            concatWithPrevious === true &&
            this.state.postLatestList &&
            this.state.postLatestList.content
          ) {
            pagedData.content = this.state.postLatestList.content.concat(
              pagedData.content
            );
          }
          this.setState(
            {
              postLatestList: pagedData,
              responseMessage: response.data.message,
              isResultLoading: false,
            },
            () => {
              let postListHeight = $(".hpostlist").height();
              if (postListHeight && postListHeight > 0) {
                if (!this.state.initialThresholdHeight) {
                  this.setState({
                    initialThresholdHeight: postListHeight,
                    thresholdHeight: postListHeight * 0.6,
                  });
                }
              }
            }
          );
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          isResultLoading: false,
        });
      });
  }

  render() {
    return (
      <section className="hpostlist">
        {this.state.postLatestList &&
          this.state.postLatestList.content &&
          this.state.postLatestList.content.map((item) => {
            return item.postType === "ARTICLE" ? (
              <UnAuthArticlePostItem
                enablePostSharing={true}
                item={item}
                key={item.id}
              />
            ) : item.attachmentIds && item.attachmentIds.length > 0 ? (
              item.attachmentIds[0].attachmentType === "VIDEO" ? (
                <LazyLoad once>
                  <UnAuthVideoPostItem item={item} key={item.id} />
                </LazyLoad>
              ) : item.attachmentIds[0].attachmentType === "AUDIO" ? (
                <LazyLoad once>
                  <UnAuthAudioPostItem item={item} key={item.id} />
                </LazyLoad>
              ) : (
                <LazyLoad once>
                  <UnAuthPhotosPostItem item={item} key={item.id} />
                </LazyLoad>
              )
            ) : item.postType === "LINK" ? (
              <LazyLoad once>
                <UnAuthLinkPostItem
                  enablePostSharing={true}
                  item={item}
                  key={item.id}
                />
              </LazyLoad>
            ) : item.sharedEntityId && item.sharedEntityId !== "" ? (
              <UnAuthSharePostItem
                enablePostSharing={true}
                item={item}
                key={item.id}
              />
            ) : (
              <UnAuthQuotePostItem item={item} key={item.id} />
            );
          })}
      </section>
    );
  }
}
